/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AppCustomerOnboardingCategoryDto } from './AppCustomerOnboardingCategoryDto';

export type AppCustomerOnboardingRequestDto = {
    categories: Array<AppCustomerOnboardingCategoryDto>;
    gender: AppCustomerOnboardingRequestDto.gender;
    ageRange: string;
};

export namespace AppCustomerOnboardingRequestDto {

    export enum gender {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
        '_9' = 9,
    }


}
